import React, { useState, lazy, Suspense, useRef, useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import HashLoader from "react-spinners/HashLoader";
import Store from "../store/store";
import GlobalCss from "../modules/global/css";
import { Center, Container } from "@chakra-ui/react";
import Sightseen from "../modules/tourArea/components/Sightseen";
import AddSightseen from "../modules/tourArea/components/AddSightseen";
import Layout from "../modules/global/components/layout";
import PortalForLayout from "../modules/global/components/PortalForLayout";

const Dashboard = lazy(() => import("../modules/dashboard/components"));
const Quotation = lazy(() => import("../modules/quotation/components"));
const AddQuotation = lazy(() => import("../modules/quotation/components/AddQuotation"));
const Itenary = lazy(() => import("../modules/itenary/components"));
const ItenaryDetails = lazy(() => import("../modules/itenary/components/ItenaryDetails"));
const AddItenary = lazy(() => import("../modules/itenary/components/AddItenary"));
const Hotel = lazy(() => import("../modules/hotel/components"));
const AddHotel = lazy(() => import("../modules/hotel/components/AddHotel"));
const HotelDetails = lazy(() => import("../modules/hotel/components/HotelDetails"));
const AllComments = lazy(() => import("../modules/quotation/components/AllComments"));
const AdminQrCode = lazy(() => import("../modules/adminQr/components/AdminQrCode"));
const Login = lazy(() => import("../modules/login/components"));
const LinksShowPDF = lazy(() => import("../modules/quotation/components/LinksShowPDF"));
const RejectedQuote = lazy(() => import("../modules/rejectedQuote/components"));
const SendQuotation = lazy(() => import("../modules/quotation/components/SendQuotation"));
const CopyLink = lazy(() => import("../modules/quotation/components/CopyLink"));
const ViewTours = lazy(() => import("../modules/tour/components/ViewTours"));
const ViewEditTour = lazy(() => import("../modules/tour/components/ViewEditTour"));
const ViewItineraries = lazy(() => import("../modules/tour/components/ViewItineraries"));
const ViewEditItinerary = lazy(() => import("../modules/tour/components/ViewEditItinerary"));
const AddTour = lazy(() => import("../modules/tour/components/AddTour"));
const AddItinerary = lazy(() => import("../modules/tour/components/AddItinerary"));
const AddAvailability = lazy(() => import("../modules/tour/components/AddAvailability"));
const AdminQuotation = lazy(() => import("../modules/adminQuotation/components"));
const ActivityCategory = lazy(() => import("../modules/activityCategory/components"));
const TourArea = lazy(() => import("../modules/tourArea/components"));
const Blog = lazy(() => import("../modules/blogs/components"));
const Offer = lazy(() => import("../modules/offers/components"));
const User = lazy(() => import("../modules/users/components"));
const MetaData = lazy(() => import("../modules/metaData/components"));
const MetaDataForm = lazy(() => import("../modules/metaData/components/MetaDataForm"));

const AllRoutes = ({ onLogout }) => {
  const locate = useLocation();
  const [globalStaticFragmennt, setGlobalStaticFragmennt] = useState(true);
  const commonPortalRef = useRef();

  useEffect(() => {
    const handleWheel = (e) => {
      const target = document.activeElement;
      if (target && target.type === "number") {
        target.blur();
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <>
      {globalStaticFragmennt && <Layout portalId={commonPortalRef} onLogout={onLogout} />}
      <Suspense
        fallback={
          <Center h="100vh">
            <HashLoader color="#105380" size={20} speedMultiplier={1} />
          </Center>
        }
      >
        <Routes location={locate} key={locate.key}>
          <Route
            path="/"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Dashboard globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/tour-area/:id/sightseen"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Sightseen />
              </PortalForLayout>
            }
          />
          <Route
            path="/admin/meta-data/*"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Routes>
                  <Route path="/" element={<MetaData />} />
                  <Route path="add" element={<MetaDataForm />} />
                  <Route path="edit/:id" element={<MetaDataForm />} />
                </Routes>
              </PortalForLayout>
            }
          />
          <Route
            path="/tour-area/:id/sightseen/add"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <AddSightseen />
              </PortalForLayout>
            }
          />
          <Route
            path="/itenary"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Itenary globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/itenary-details/:id"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <ItenaryDetails globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/add-itenary"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <AddItenary globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/quotation"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Quotation globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/add-quotation"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <AddQuotation globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/send-quotation/:id"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <SendQuotation globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/links/:encryptId"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <LinksShowPDF globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />

          <Route
            path="/comments/:id"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <AllComments globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/hotel"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Hotel globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/hotel-details/:id"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <HotelDetails globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/add-hotel"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <AddHotel globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/rejected-quote"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <RejectedQuote globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/copy-link/:codeLink"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <CopyLink globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/activity-category/*"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Routes>
                  <Route path="/" element={<ActivityCategory globalLayout={setGlobalStaticFragmennt} />} />
                  <Route path="add" element={<ActivityCategory globalLayout={setGlobalStaticFragmennt} />} />
                  <Route path="edit/:id" element={<ActivityCategory globalLayout={setGlobalStaticFragmennt} />} />
                </Routes>
              </PortalForLayout>
            }
          />
          <Route
            path="/admin/qr-code"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <AdminQrCode globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/tour-area/*"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Routes>
                  <Route path="/" element={<TourArea globalLayout={setGlobalStaticFragmennt} />} />
                  <Route path="add" element={<TourArea globalLayout={setGlobalStaticFragmennt} />} />
                  <Route path="edit/:id" element={<TourArea globalLayout={setGlobalStaticFragmennt} />} />
                </Routes>
              </PortalForLayout>
            }
          />
          <Route
            path="/view-tours"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <ViewTours globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/edit-tour/:id"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <ViewEditTour globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/view_edit_tour/:tourId"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <ViewEditTour globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/view-itineraries"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <ViewItineraries globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/view_edit_itinerary/:tourId"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <ViewEditItinerary globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/add_tour"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <AddTour />
              </PortalForLayout>
            }
          />
          <Route
            path="/add_itinerary/:tourId"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <AddItinerary />
              </PortalForLayout>
            }
          />
          <Route
            path="/add_availability/:tourId"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <AddAvailability />
              </PortalForLayout>
            }
          />
          <Route
            path="/view-quotes"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <AdminQuotation globalLayout={setGlobalStaticFragmennt} />
              </PortalForLayout>
            }
          />
          <Route
            path="/admin/blogs/*"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Routes>
                  <Route path="/" element={<Blog globalLayout={setGlobalStaticFragmennt} />} />
                  <Route path="add" element={<Blog globalLayout={setGlobalStaticFragmennt} />} />
                  <Route path="edit/:id" element={<Blog globalLayout={setGlobalStaticFragmennt} />} />
                </Routes>
              </PortalForLayout>
            }
          />
          <Route
            path="/admin/offers/*"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Routes>
                  <Route path="/" element={<Offer globalLayout={setGlobalStaticFragmennt} />} />
                  <Route path="add" element={<Offer globalLayout={setGlobalStaticFragmennt} />} />
                  <Route path="edit/:id" element={<Offer globalLayout={setGlobalStaticFragmennt} />} />
                </Routes>
              </PortalForLayout>
            }
          />
          <Route
            path="/admin/users/*"
            element={
              <PortalForLayout globalLayout={globalStaticFragmennt} portalId={commonPortalRef}>
                <Routes>
                  <Route path="/" element={<User globalLayout={setGlobalStaticFragmennt} />} />
                  <Route path="add" element={<User globalLayout={setGlobalStaticFragmennt} />} />
                  <Route path="edit/:id" element={<User globalLayout={setGlobalStaticFragmennt} />} />
                </Routes>
              </PortalForLayout>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
};

// 🚀 RouteHolder: Handles Auth Switching
const RouteHolder = () => {
  const [isAuth, setIsAuth] = useState(() => !!localStorage.getItem("hthUser"));

  return (
    <Provider store={Store}>
      <GlobalCss />
      <Container display="flex" flexDirection="row" justifyContent="center" className="wrapper" p={0} maxW="100vw" minH="100vh" color="grey.100">
        <Router>
          {isAuth ? (
            <AllRoutes
              onLogout={() => {
                setIsAuth(false);
                window.location.href = "/";
              }}
            />
          ) : (
            <Routes>
              <Route path="/" element={<Login onLoginSuccess={() => setIsAuth(true)} />} />
              <Route path="/links/:encryptId" element={<LinksShowPDF />} />
            </Routes>
          )}
        </Router>
      </Container>
    </Provider>
  );
};

export default RouteHolder;
